import { lazy } from 'react';
import { PermissionEn } from '@martech-solution/utils/constants';
import preSalePath from 'src/constants/urlPath/crm/preSalePath';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../../layouts/NewFeatures/MainLayout';

const PreSale = lazy(() => import('src/pages/CRM/PreSale'));
const Lead = lazy(() => import('src/pages/CRM/PreSale/Lead'));
const LeadForm = lazy(() => import('src/pages/CRM/PreSale/Lead/LeadForm'));

const preSaleRoutes: RouteType[] = [
  {
    path: preSalePath.preSale,
    Layout: NewLayout,
    Component: PreSale
  },
  // Lead
  {
    path: preSalePath.lead,
    Layout: NewLayout,
    Component: Lead,
    checkPath: preSalePath.lead,
    permission: PermissionEn.read
  },
  {
    path: `${preSalePath.leadDetail}/:id`,
    Layout: NewLayout,
    Component: LeadForm,
    checkPath: preSalePath.lead,
    permission: PermissionEn.viewDetail
  },
  {
    path: preSalePath.leadAdd,
    Layout: NewLayout,
    Component: LeadForm,
    checkPath: preSalePath.lead,
    permission: PermissionEn.create
  },
  {
    path: `${preSalePath.leadEdit}/:id`,
    Layout: NewLayout,
    Component: LeadForm,
    checkPath: preSalePath.lead,
    permission: PermissionEn.update
  }
];

export default preSaleRoutes;
